@layer token {
  :root {
    /* BASE ----------------------------------------------------------------- */

    --n-icon-size-xs: var(--n-scale-300);
    --n-icon-size-sm: var(--n-scale-400);
    --n-icon-size-md: var(--n-scale-500);
    --n-icon-size-lg: var(--n-scale-600);
    --n-icon-size-xl: var(--n-scale-800);
  }
}

@layer component {
  /* BASE ------------------------------------------------------------------- */

  /*
   * Stroke widths are in the 12-unit viewBox's own units, so the rendered width
   * is `stroke-width × box ÷ 12`. Each size below solves that for the pixel
   * width it should paint. The alternative, vector-effect: non-scaling-stroke,
   * pinned the value to pixels directly but put every icon at the mercy of one
   * rendering property — Chrome 151 regressed it and thinned every icon on
   * Retina, in Chrome only.
   */
  .icon {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    stroke: currentColor;
    stroke-width: 1.2;
    fill: none;
    font-size: 0;
  }

  .svg {
    stroke: inherit;
    fill: inherit;
  }

  .narvar-logoIcon .svg,
  .refundIcon .svg,
  .googleIcon .svg,
  .microsoftIcon .svg {
    stroke: transparent;
  }

  /* SIZES ------------------------------------------------------------------ */

  /* 12px box, paints 1px */
  .xsSize {
    width: var(--n-icon-size-xs);
    height: var(--n-icon-size-xs);
    stroke-width: 1;
  }

  /* 16px box, paints 1.5px */
  .smSize {
    width: var(--n-icon-size-sm);
    height: var(--n-icon-size-sm);
    stroke-width: 1.125;
  }

  /* 20px box, paints 2px — the base value */
  .mdSize {
    width: var(--n-icon-size-md);
    height: var(--n-icon-size-md);
  }

  /* 24px box, paints 2px */
  .lgSize {
    width: var(--n-icon-size-lg);
    height: var(--n-icon-size-lg);
    stroke-width: 1;
  }

  /* 32px box, paints 2px */
  .xlSize {
    width: var(--n-icon-size-xl);
    height: var(--n-icon-size-xl);
    stroke-width: 0.75;
  }

  /*
   * The box is sized in em, so unlike the fixed sizes this one cannot resolve to
   * a set pixel width. Keeping the base value makes the stroke track the text it
   * sits in, painting 0.125em: 1.625px in the 13px input messages that are its
   * main caller, and exactly md's 2px at 16px text. Past 16px it outweighs every
   * fixed size, so headings should use one of those instead.
   */
  .fontSize {
    width: 1.25em;
    height: 1.25em;
    font-size: 1em;
  }
}
